import { CartObserverProvider } from "../cart";
import { DataStore } from "@/datastore";
import { Demographic } from "./types";
import { ArithmeticProvider } from "../arithmetic";
import { RetargetingPlugsProvider } from "@/providers/retargeting-plugs";

export function getSessionScore(): number {
  const persona = window.helium.attributes.strongestInference || {};
  let finalScoreForPersona = 0;

  (Object.keys(persona) as Array<keyof Demographic>).forEach((key) => {
    if (!persona[key] || !key) {
      return;
    }

    finalScoreForPersona +=
      +sessionScoreWeights[key][
        persona[key] as keyof (typeof sessionScoreWeights)[typeof key]
      ];
  });

  const personaContribution = 0.2;

  const productIntent =
    Object.values(DataStore.getSectionScores()).reduce(
      (sum, score) => sum + score,
      0,
    ) / Object.keys(DataStore.getSectionScores()).length;

  const productIntentContribution = 0.4;

  const cartOperations = CartObserverProvider.getAllCartOperations().length;

  const cartOperationsNormalised = ArithmeticProvider.clipToRange(
    cartOperations * 20,
    0,
    100,
  );
  const likelihoodValue =
    window?.helium?.attributes?.ecommerce?.secondary?.likelihoodToConvert || 0;

  const cartOperationsContribution = 0.4;

  if (typeof likelihoodValue !== "undefined" && likelihoodValue > 0) {
    RetargetingPlugsProvider.setUserAttribute(
      "H_INTENT_SCORE",
      likelihoodValue,
    );
  }

  return likelihoodValue;

  // return (
  //   finalScoreForPersona * personaContribution +
  //   productIntent * productIntentContribution +
  //   cartOperationsNormalised * cartOperationsContribution
  // );
}

const sessionScoreWeights = {
  age: {
    "18-24": 0.4,
    "25-34": 0.7,
    "35-44": 0.8,
    "45-54": 0.6,
    "55-64": 0.5,
    "65+": 0.3,
  },
  gender: {
    Male: 0.6,
    Female: 0.8,
    "Non-binary": 0.5,
    "Gender fluid": 0.5,
    "Prefer not to say": 0.4,
  },
  occupation: {
    Student: 0.5,
    "Self-employed": 0.7,
    Freelancer: 0.6,
    "Entry-level professional": 0.5,
    "Mid-level professional": 0.7,
    "Senior professional": 0.8,
    Executive: 0.9,
    Unemployed: 0.3,
    Retired: 0.4,
    Homemaker: 0.5,
  },
  income_level: {
    "Under $20,000": 0.2,
    "$20,000 - $39,999": 0.4,
    "$40,000 - $59,999": 0.6,
    "$60,000 - $79,999": 0.7,
    "$80,000 - $99,999": 0.8,
    "$100,000 - $149,999": 0.9,
    "$150,000+": 1.0,
  },
  education_level: {
    "No formal education": 0.2,
    "High School Diploma": 0.4,
    "Associate's Degree": 0.5,
    "Bachelor's Degree": 0.7,
    "Master's Degree": 0.8,
    Doctorate: 0.9,
    "Professional Certification": 0.6,
  },
  marital_status: {
    Single: 0.6,
    Married: 0.8,
    Divorced: 0.4,
    Widowed: 0.3,
    "In a relationship": 0.7,
    Engaged: 0.7,
  },
  family_structure: {
    "No children": 0.5,
    "One child": 0.6,
    "Two children": 0.7,
    "Three children or more": 0.8,
    "Extended family": 0.7,
  },
};
